
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";
import { ExtendedSpinAndHold2 } from "./ExtendedSpinAndHold2";

export interface IExtendedSpinAndHold2Factory
{
	CreateExtendedSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): ExtendedSpinAndHold2;
}

export class ExtendedSpinAndHold2Factory implements IExtendedSpinAndHold2Factory
{
	public CreateExtendedSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): ExtendedSpinAndHold2
	{
		return new ExtendedSpinAndHold2(gameName, params, config);
	}
}